import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import TextEditorButton from '../text-editor-button';

export default function createSizeButton({ size, content: Content, tooltipText }) {
  return class SizeButton extends Component {
    static propTypes = {
      setSize: PropTypes.func.isRequired,
      size: PropTypes.string,
      className: PropTypes.string,
    };

    isActive = () => this.props.size === size;
    handleClick = () => this.props.setSize(size);

    render() {
      const {
        setSize, // eslint-disable-line no-unused-vars
        size, // eslint-disable-line no-unused-vars
        className,
        ...buttonProps
      } = this.props;
      return (
        <TextEditorButton
          className={classNames(className, `text-editor__size-${_.kebabCase(size)}-button`)}
          icon={Content}
          onClick={this.handleClick}
          isActive={this.isActive()}
          tooltipText={tooltipText}
          {...buttonProps}
        />
      );
    }
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/utils/create-size-button.js